import { Box, BoxProps, Heading, SingleSelect, smBumps } from '@wrisk/ui-components'
import React, { FunctionComponent, useMemo } from 'react'

import {
  TKeyBuilder,
  tProduct,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'

export interface CoverLevelSelectionProps extends BoxProps {
  tKey: TKeyBuilder
  coverLevels: string[]
  value?: string
  onChange: (coverLevel: string) => void
  loading?: boolean
}

const key = 'cover-levels'

export const CoverLevelSelection: FunctionComponent<CoverLevelSelectionProps> = ({
  coverLevels,
  onChange,
  value,
  loading,
  tKey,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const header = t(tKey(key, 'header'), { defaultValue: null })

  const selectOptions = useMemo(
    () =>
      coverLevels.reduce(
        (acc, level) => ({
          ...acc,
          [level]: t(tProduct(key, level)),
        }),
        {},
      ),
    [coverLevels],
  )

  return coverLevels.length > 1 ? (
    <Box display='flex' flexDirection='column' gap={smBumps} width={1} {...props}>
      {header && (
        <Heading variant='h4' as='h4' typoSize='md'>
          {header}
        </Heading>
      )}
      <SingleSelect
        name={'coverLevelSelection'}
        options={selectOptions}
        value={value}
        onChange={onChange}
        width={1}
        disabled={loading}
      />
    </Box>
  ) : null
}
